import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=79e01e64&scoped=true&"
import script from "./checkbox.ts?vue&type=script&lang=ts&"
export * from "./checkbox.ts?vue&type=script&lang=ts&"
import style0 from "./checkbox.scss?vue&type=style&index=0&id=79e01e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e01e64",
  null
  
)

export default component.exports